import type { FaireProductEntity } from "../../entity_types/product";

export const p_5ngtaerd9j: FaireProductEntity = {
  token: "p_5ngtaerd9j",
  type: "product",
  name: "Rice Water Shampoo & Conditioner Bar Combo for Hair Growth",
  brandToken: "b_dljmfs9o",
  brandName: "KITSCH",
  imageUrl:
    "https://cdn.faire.com/fastly/d8cbbf32e314e036189a2ba9b511c53c465828042a00a017855e79d317e62366.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/703f1b0510d1a76503c9d25c9f717dc5572b36be7d58cd56c170ba7d31f0b7c6.jpeg",
    "https://cdn.faire.com/fastly/6e31eaa83927d94a0ade15c34e99665fe655a045ecf9f398b33a4fcedec3e2e5.jpeg",
    "https://cdn.faire.com/fastly/9ca3c351b742e61539bf0eea8dfae3bc3bb0c275ecc020a92481f989945789c7.jpeg",
    "https://cdn.faire.com/fastly/3b368eba0e3c5b33d0ffef3e0d0e5e2e2d0d70f7b2a315d7fe0cd3423aa157d6.jpeg",
    "https://cdn.faire.com/fastly/b809b5410a1d6cdf46c890e2399fc84cde958de5222e3d3a239a586f7a68d6ad.jpeg",
  ],
  priceDollars: 14,
  description:
    "Formulated with Rice Tien Protein, clinically proven to increase hair volume and improve appearance of natural shine in just five washes.\nRice Protein has been shown to increase hair volume by 20% after 5 washes* based on TRI-K Rice Tein NPNF study after 5 washes\nGives you a nourishing cleanse to encourage overall hair length & density\nBoosts shine in dull, dry hair\nFree of parabens, phthalates, silicones, sulfates, & artificial fragrance\n\nWhy You'll Love This:\n\nMade in the USA\nKitsch is a 4ocean Certified Cleanup Partner. For every shampoo or conditioner bar you purchase, 4ocean pulls the equivalent of one shampoo bottle’s worth of plastic from the world's oceans, rivers, and coastlines.\nShampoo and Conditioner Set\n",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:21.330Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
